import React, { Component, PropTypes } from 'react';
import forEach from 'lodash/forEach';
import { casesRoute } from '../../routes';
import {Link} from 'react-router';
import Image from '../../components/image/image';

export default class ContextualCaseSingle extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props.id !== nextProps.id ||
			this.props.case.id !== nextProps.case.id ||
			this.props.browser.window.width !== nextProps.browser.window.width
		);

	}

	render() {
		let profiles = '';
		let _this = this;

		if (this.props.case.profiles) {
			forEach(this.props.case.profiles, function(profile, i) {
				if (i == _this.props.case.profiles.length - 1) {
					profiles += profile.name;
				} else {
					profiles += profile.name + ', ';
				}
			});
		}

		return (
			<li className='contextual-menu__inner-list__cases__case span2 span4-tablet span14-mobile'>
				<Link to={casesRoute(this.props.case.slug)} onClick={this.props.onClick}>
				{this.props.case.thumbnail && (
					<div className='contextual-menu__inner-list__cases__case__image pixel-pattern pixel-pattern--darker'>
						<Image img={this.props.case.thumbnail} span={{ desktop: 'span4', tablet: 'span4', mobile: 'span14' }} browser={this.props.browser} />
					</div>
				)}
				<div className='contextual-menu__inner-list__cases__case__content'>
					<h2 className='contextual-menu__inner-list__cases__case__title'>{this.props.case.title}</h2>
					<span className='contextual-menu__inner-list__cases__case__byline'>{profiles}</span>
				</div>
				</Link>
			</li>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/contextual/contextualCaseSingle.js
 **/